import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16cc0c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tqc-eyebrow" }, "Proofreading Test", -1 /* HOISTED */))
const _hoisted_2 = { class: "nge-tqc-main" }
const _hoisted_3 = { class: "nge-tqc-time" }
const _hoisted_4 = { class: "nge-tqc-btns" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "nge-tqc-main" }
const _hoisted_7 = { class: "nge-tqc-sub" }
const _hoisted_8 = { class: "nge-tqc-btns" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 2,
  class: "nge-tqc-err",
  role: "alert"
}
const _hoisted_11 = { class: "nge-tqc-sub" }
const _hoisted_12 = { class: "nge-tqc-btns" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.inLine || $setup.gone)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ng-extend nge-tqc", { 'nge-tqc--turn': $setup.called }]),
        role: "status",
        "aria-live": "polite"
      }, [
        ($setup.inLine && $setup.q)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_1,
              ($setup.called)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", _hoisted_2, [
                      _createTextVNode("It is your turn. The cell is held for you for "),
                      _createElementVNode("b", _hoisted_3, _toDisplayString($setup.left), 1 /* TEXT */),
                      _createTextVNode(".")
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-hud-btn nge-hud-btn--sm nge-hud-btn--go",
                        onClick: $setup.start
                      }, "Start the test"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-hud-btn nge-hud-btn--sm nge-hud-btn--quiet",
                        disabled: $setup.queueBusy,
                        title: "Give your turn to the next player",
                        onClick: $setup.leave
                      }, "Not now", 8 /* PROPS */, _hoisted_5)
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_6, [
                      _createTextVNode("You are "),
                      _createElementVNode("b", null, _toDisplayString($setup.ordinal($setup.q.position || 1)), 1 /* TEXT */),
                      _createTextVNode(" in line.")
                    ]),
                    _createElementVNode("p", _hoisted_7, _toDisplayString($setup.waitWords($setup.q)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-hud-btn nge-hud-btn--sm nge-hud-btn--quiet",
                        disabled: $setup.queueBusy,
                        onClick: $setup.leave
                      }, "Leave the line", 8 /* PROPS */, _hoisted_9)
                    ])
                  ], 64 /* STABLE_FRAGMENT */)),
              ($setup.queueError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.queueError), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", _hoisted_11, _toDisplayString($setup.gone), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "nge-hud-btn nge-hud-btn--sm",
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.gone = ''))
                }, "OK")
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}